import React, { useState } from 'react';
import { career as C } from '../data/pages';
import { careers } from '../data/company';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

const empty = { first: '', last: '', email: '', phone: '', message: '' };
const perkIcons = ['card', 'clock', 'team', 'spark', 'school', 'loop', 'shield', 'pin', 'building', 'support', 'target', 'globe'];
const whyIcons = ['spark', 'loop', 'clock', 'team'];

// Generated "team photo" tiles (stand-ins for the reference's photographs).
function Tile({ tone }) {
  return (
    <svg viewBox="0 0 200 140" aria-hidden="true" preserveAspectRatio="xMidYMid slice">
      <rect width="200" height="140" fill={tone === 1 ? '#34373f' : tone === 2 ? '#0b2a15' : '#061609'} />
      <rect y="100" width="200" height="40" fill="#fff" opacity=".05" />
      {[40, 80, 120, 160].map((x, i) => (
        <g key={x} opacity={0.5 + (i % 2) * 0.25}>
          <circle cx={x} cy={62 - (i % 2) * 8} r="13" fill="#80c342" />
          <path d={`M${x - 20} 120c0-24 12-34 20-34s20 10 20 34z`} fill="#80c342" opacity=".7" />
        </g>
      ))}
    </svg>
  );
}

export default function Career() {
  const [f, setF] = useState(empty);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const mail = careers.email;

  // Static site: the form opens the visitor's email app with the details filled in.
  const submit = (e) => {
    e.preventDefault();
    const body = `Name: ${f.first} ${f.last}\nEmail: ${f.email}\nPhone: ${f.phone}\n\n${f.message}\n\n(Please attach your CV to this email.)`;
    window.location.href = `mailto:${mail}?subject=${encodeURIComponent('Career enquiry')}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <section className="chero">
        <div className="container">
          <div className="chero__card">
            <h1>{C.hero.title}</h1>
            <div className="collage" aria-hidden="true">
              {[1, 0, 2, 0, 1].map((t, i) => (<div key={i} className={`collage__t collage__t--${i}`}><Tile tone={t} /></div>))}
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading row title={C.whyTitle} text={C.whyText} />
          <div className="grid grid--4">
            {C.why.map((w, i) => (
              <Reveal key={w.title} delay={i * 70}>
                <article className="card wcard">
                  <Icon name={whyIcons[i % 4]} size={52} />
                  <h3>{w.title}</h3>
                  <p>{w.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading row title={C.perksTitle} text={C.perksText} />
          <Reveal>
            <ul className="perklist">
              {C.perks.map((p, i) => (
                <li key={p}><span><Icon name={perkIcons[i % perkIcons.length]} size={20} /></span>{p}</li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal>
            <h2 className="bigh bigh--md">{C.openingsNote.title}</h2>
            <p className="notice__p">{C.openingsNote.text}</p>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container apply">
          <Reveal className="apply__panel">
            <Icon name="team" size={72} />
            <h3>Your next role starts here</h3>
            <p>We are a team that values clear thinking, careful engineering and honest collaboration. Tell us a little about yourself.</p>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="bigh bigh--md">Didn't Find Your Ideal Role?</h2>
            <p className="notice__p notice__p--left">We'd still love to hear from you. Share your details and we'll reach out when a matching opportunity opens.</p>
            <form className="aform" onSubmit={submit}>
              <label>First Name<input required placeholder="First Name" value={f.first} onChange={set('first')} autoComplete="given-name" /></label>
              <label>Last Name<input required placeholder="Last Name" value={f.last} onChange={set('last')} autoComplete="family-name" /></label>
              <label>Email<input required type="email" placeholder="Enter your email" value={f.email} onChange={set('email')} autoComplete="email" /></label>
              <label>Phone Number<input type="tel" placeholder="Enter your phone number" value={f.phone} onChange={set('phone')} autoComplete="tel" /></label>
              <label className="aform__full">Message<textarea rows="4" placeholder="Write your message..." value={f.message} onChange={set('message')} /></label>
              <p className="aform__note aform__full">Submitting opens your email app with these details. Attach your CV (PDF or DOC) before sending.</p>
              <button className="btn btn--submit aform__full" type="submit">Submit</button>
            </form>
          </Reveal>
        </div>
      </section>
    </>
  );
}
